const resellers = {
    'resellers.add': 'Reseller uitnodigen',
    'resellers.add.explanation': 'Voer een bedrijfsnaam en contactpersoon in om een uitnodiging te versturen.',

    'resellers.dashboard.table.company': 'Bedrijf',
    'resellers.dashboard.table.username': 'Gebruikernaam',
    'resellers.dashboard.table.webshops': 'Webshops',
    'resellers.dashboard.table.feeds': 'Feeds',
    'resellers.dashboard.table.connections': 'Connecties',
    'resellers.dashboard.table.subscriptions': 'Abonnementen tot en met',
    'resellers.dashboard.table.status': 'Status',
    'resellers.dashboard.table.empty': 'Er zijn geen klanten gevonden',
    'resellers.summary': 'Mijn resellergegevens',
    'resellers.summary.save': 'Reseller opslaan',
    'resellers.summary.saving': 'Reseller wordt opgeslagen...',
    'resellers.summary.reseller': 'Reseller',
    'resellers.summary.contact_information': 'Contactinformatie',
    'resellers.summary.setup_completed': 'Het lijkt er op dat je nog niet alle informatie ingevuld hebt',
    'resellers.summary.text': 'Dit zijn de gegevens van je resellers. Zorg dat deze informatie up-to date is.',
};

export default resellers;
